import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import HistoryTable from 'components/history/HistoryTable'
import { usersQuery } from 'hooks/users'

export const Route = createFileRoute('/_auth/_admin/admin/history')({
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(usersQuery)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const users = Route.useLoaderData()

  return (
    <Stack gap="xl" mt="xl">
      <HistoryTable users={users} />
    </Stack>
  )
}
